var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-message--system", style: _vm.messageColors },
    [
      _vm._t(
        "default",
        function () {
          return [
            _c("span", {
              staticStyle: {
                "word-break": "break-word",
                "max-width": "475px",
                "font-family": "Inter, sans-serif",
              },
              domProps: { innerHTML: _vm._s(_vm.processedText) },
            }),
            _vm._v(" "),
            _vm.data.meta
              ? _c(
                  "span",
                  {
                    staticClass: "sc-message--meta",
                    style: {
                      color: _vm.messageColors.color,
                      fontFamily: "Inter, sans-serif",
                    },
                  },
                  [_vm._v("\n            " + _vm._s(_vm.data.meta))]
                )
              : _vm._e(),
          ]
        },
        { message: _vm.data }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }